// @ts-nocheck
import React from 'react';
import Method from './paymentMethods/Method';

const CheckoutArea = ({
                          method,
                          value,
                          formReplies,
                          fixedValue,
                          itemPurchases,
                          donations,
                          mbStartDate,
                          mbEndDate,
                          email,
                          onEmailChange
                      }) => {

    return (
        <>
            <Method
                method={method}
                value={value}
                formReplies={formReplies}
                fixedValue={fixedValue}
                itemPurchases={itemPurchases}
                donations={donations}
                mbStartDate={mbStartDate}
                mbEndDate={mbEndDate}
                email={email}
                onEmailChange={onEmailChange}
            />
        </>
    );
};

export default CheckoutArea;